import { h } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'
import IdeationStatus from '../IdeationStatus'
import { IdeaStatus } from '@insided/control/modules/ContentModeration/TopicModeration/interfaces'

interface Props {
  oldIdeationStatus: IdeaStatus
  newIdeationStatus: IdeaStatus
}

const IdeationStatusUpdated = ({ oldIdeationStatus, newIdeationStatus }: Props) => (
  <div>
    <Phrase p='reply.idea.status.changed' m='Common' />
    <IdeationStatus
      ideationStatus={oldIdeationStatus}
    />
    →
    <IdeationStatus
      ideationStatus={newIdeationStatus}
    />
  </div>
)

export default IdeationStatusUpdated
